import axios from "axios";

export const sriAgentScheduleApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND!}api/sri-agent-schedule`,
  headers: {
    "Content-Type": "application/json",
  },
});
